import { render, staticRenderFns } from "./dissolution.vue?vue&type=template&id=e57d1488&scoped=true&"
import script from "./dissolution.vue?vue&type=script&lang=js&"
export * from "./dissolution.vue?vue&type=script&lang=js&"
import style0 from "./dissolution.vue?vue&type=style&index=0&id=e57d1488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57d1488",
  null
  
)

export default component.exports